export interface DeleteSystemGroupRequest {
  id: string
  revision: number
}

export function DeleteSystemGroupRequestToJSON(
  value: DeleteSystemGroupRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
